module.exports = __webpack_public_path__ + "static/media/29.e89a1863.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/29.jpg
// module id = 1379
// module chunks = 0